import {
  Claim,
} from 'src/containers';

export const ClaimRouter = (props) => {
	return (
		<Claim />
	)
};